import AnimatedBackground from '../components/AnimatedBackground';
import { Reveal } from '../components/Motion';
import { COMPANY } from '../data/site';

const SECTIONS = [
  {
    t: 'Données collectées',
    p: "Via le formulaire de contact, nous collectons uniquement les données nécessaires au traitement de votre demande : nom, prénom, téléphone, e-mail, adresse d’intervention, description du projet, date souhaitée et budget indicatif.",
  },
  {
    t: 'Finalité du traitement',
    p: "Les données servent exclusivement à répondre à votre demande, établir un devis, planifier l’intervention et assurer le suivi de la relation client. Elles ne sont utilisées à aucune autre fin.",
  },
  {
    t: 'Base légale',
    p: "Le traitement repose sur votre consentement explicite (case à cocher du formulaire) et sur l’exécution de mesures précontractuelles prises à votre demande.",
  },
  {
    t: 'Durée de conservation',
    p: "Les données sont conservées pendant la durée nécessaire au traitement de votre demande et à la relation contractuelle, dans la limite des obligations légales (comptables, fiscales).",
  },
  {
    t: 'Destinataires',
    p: "Seul le personnel habilité de Ponthieu Pose et Rénovation a accès à vos données. Elles ne sont ni vendues, ni louées, ni transmises à des tiers à des fins commerciales.",
  },
  {
    t: 'Droits des utilisateurs',
    p: "Conformément au RGPD, vous disposez d’un droit d’accès, de rectification, de suppression, d’opposition et de portabilité de vos données. Vous pouvez exercer ces droits en écrivant à " + COMPANY.email + '.',
  },
  {
    t: 'Sécurité',
    p: "Nous mettons en œuvre les mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès, modification, divulgation ou destruction non autorisés.",
  },
  {
    t: 'Cookies',
    p: "Ce site n’utilise pas d’outils publicitaires ou de traçage tiers. Si de tels outils venaient à être ajoutés (par exemple Google Analytics), une bannière de consentement serait affichée.",
  },
  {
    t: 'Contact',
    p: "Pour toute question relative à vos données personnelles : " + COMPANY.email + '.',
  },
];

export default function Confidentialite() {
  return (
    <section className="relative pt-24 md:pt-32 pb-24 overflow-hidden">
      <AnimatedBackground />
      <div className="relative z-10 max-w-[1100px] mx-auto px-5 md:px-10">
        <Reveal>
          <div className="overline mb-4">◍ RGPD</div>
          <h1 className="font-display italic text-6xl md:text-7xl leading-[0.95]">Politique de confidentialité.</h1>
        </Reveal>

        <div className="mt-14 space-y-12">
          {SECTIONS.map((s, i) => (
            <div key={s.t} className="grid grid-cols-1 md:grid-cols-[80px_1fr] gap-6">
              <div className="font-display italic text-4xl leading-none text-white/85">{String(i + 1).padStart(2, '0')}</div>
              <div>
                <h2 className="font-display italic text-3xl mb-4 leading-tight">{s.t}</h2>
                <p className="text-white/70 leading-relaxed max-w-3xl">{s.p}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
